import { subDays } from 'date-fns';
export var mockData = [
    {
        id: 1,
        userId: 1,
        documentId: 59078,
        workspaceId: 7,
        documentAlertConfigId: 1,
        action: 'DOCUMENT_EDIT',
        createdAt: subDays(new Date(), 3).toISOString(),
        updatedAt: subDays(new Date(), 3).toISOString(),
        document: {
            id: 59078,
            slugId: '1sWXuqnkKXDQzhSxLK3VW1igpnzcDMU6KYXvKfpBLvF4',
            title: 'Meeting Minutes',
            type: 'DOCUMENT',
            workspaceId: 7,
            createdAt: subDays(new Date(), 4).toISOString(),
            updatedAt: subDays(new Date(), 3).toISOString()
        }
    },
    {
        id: 2,
        userId: 2,
        documentId: 59092,
        workspaceId: 7,
        documentAlertConfigId: 2,
        action: 'DOCUMENT_DOWNLOAD',
        createdAt: subDays(new Date(), 2).toISOString(),
        updatedAt: subDays(new Date(), 2).toISOString(),
        document: {
            id: 59092,
            slugId: '2sWXuqnkKXDQzhSxLK3VW1igpnzcDMU6KYXvKfpBLvF4',
            title: 'Legal Agreement',
            type: 'DOCUMENT',
            workspaceId: 7,
            createdAt: subDays(new Date(), 4).toISOString(),
            updatedAt: subDays(new Date(), 2).toISOString()
        }
    },
    {
        id: 3,
        userId: 3,
        documentId: 59095,
        workspaceId: 7,
        documentAlertConfigId: 2,
        action: 'DOCUMENT_SHARE',
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        document: {
            id: 59095,
            slugId: '3sWXuqnkKXDQzhSxLK3VW1igpnzcDMU6KYXvKfpBLvF4',
            title: 'Company Policies',
            type: 'DOCUMENT',
            workspaceId: 7,
            createdAt: subDays(new Date(), 4).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 4,
        userId: 4,
        documentId: 57896,
        workspaceId: 7,
        documentAlertConfigId: 3,
        action: 'DOCUMENT_EDIT',
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        document: {
            id: 57896,
            slugId: '4sWXuqnkKXDQzhSxLK3VW1igpnzcDMU6KYXvKfpBLvF4',
            title: 'Q2 Financial Report 2024',
            type: 'DOCUMENT',
            workspaceId: 7,
            createdAt: subDays(new Date(), 4).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    },
    {
        id: 5,
        userId: 5,
        documentId: 57867,
        workspaceId: 7,
        documentAlertConfigId: 3,
        action: 'DOCUMENT_COPY',
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        document: {
            id: 57867,
            slugId: '5sWXuqnkKXDQzhSxLK3VW1igpnzcDMU6KYXvKfpBLvF4',
            title: 'Q3 Financial Report 2024',
            type: 'DOCUMENT',
            workspaceId: 7,
            createdAt: subDays(new Date(), 4).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString()
        }
    }
];
